import { render, staticRenderFns } from "./ObjectChildren.vue?vue&type=template&id=566ad8b8&scoped=true"
import script from "./ObjectChildren.vue?vue&type=script&lang=js"
export * from "./ObjectChildren.vue?vue&type=script&lang=js"
import style0 from "./ObjectChildren.vue?vue&type=style&index=0&id=566ad8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ad8b8",
  null
  
)

export default component.exports